export default __webpack_public_path__ + "static/media/WEXPOLY.8ed714eb.png";